/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Platform_UxInputs */

const en_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform UX`)
};

const ar_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجربة المنصة`)
};

const bn_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্ম UX`)
};

const de_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform-UX`)
};

const es_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataforma UX`)
};

const fr_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UX de la plateforme`)
};

const pt_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência do usuário da plataforma`)
};

const zh_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台用户体验`)
};

const tr_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Kullanıcı Deneyimi`)
};

const ru_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UX платформы`)
};

const pl_svchip_platform_ux = /** @type {(inputs: Svchip_Platform_UxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UX platformy`)
};

/**
* | output |
* | --- |
* | "Platform UX" |
*
* @param {Svchip_Platform_UxInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_platform_ux = /** @type {((inputs?: Svchip_Platform_UxInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Platform_UxInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_platform_ux(inputs)
	if (locale === "bn") return bn_svchip_platform_ux(inputs)
	if (locale === "de") return de_svchip_platform_ux(inputs)
	if (locale === "es") return es_svchip_platform_ux(inputs)
	if (locale === "fr") return fr_svchip_platform_ux(inputs)
	if (locale === "pt") return pt_svchip_platform_ux(inputs)
	if (locale === "zh") return zh_svchip_platform_ux(inputs)
	if (locale === "tr") return tr_svchip_platform_ux(inputs)
	if (locale === "ru") return ru_svchip_platform_ux(inputs)
	if (locale === "pl") return pl_svchip_platform_ux(inputs)
	return en_svchip_platform_ux(inputs)
});